import * as React from "react";
import { useState, useEffect } from "react";
import { cn } from "../../../modules/metajson-sub/src/libs/helpers/Utils";
import { I18NString } from "../../../components/Utils";
import { File as FileInput } from "../../../modules/metajson-sub/src/libs/controls/Files/components/File/File";
import { checkValidFormat } from "../../../modules/metajson-sub/src/libs/controls/Files/helpers";
import { Alert } from "../../../modules/metajson-sub/src/libs/controls/Files/components/Alert/Alert";
import { InputBtns } from "./InputBtns";
import {Guid} from "../../Utils";

interface IRadiobuttonOption {
	label: I18NString;
	name: string;
}

export interface FileValue {
	id: string | null,
	url: string | null,
	name: string | null,
	isBase64?: boolean
}

const FileOption = ({
    schema,
    api,
    error,
    visited,
    dispatcher,
    opts,
    information,
    values,
    rowIndex,
}) => {
    const { options, required, contentNumb, id, title } = schema;
	const [inputs, setInputs] = React.useState(null);
    const [checkedOption, setCheckedOption] = useState(null);
    const [warning, setWarning] = useState(null);
    const [isDescriptionOpened, setIsDescriptionOpened] = useState(false);
    const [description, setDescription] = useState(null);

    const DEFAULT_FILE_SIZE = 1048576;
    const DEFAULT_MAX_SIZE = DEFAULT_FILE_SIZE * 10;

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target;
        setCheckedOption(options.find(option => option.name === value));
        setIsDescriptionOpened(false);
        setDescription(null);

        if (inputs && Object.keys(inputs).length > 0) {
            Object.keys(inputs).forEach((key) => {
                onDelete(null, inputs[key].id)
            });
        };
    };

	const onUpload = (fieldId: string) => async (event: React.ChangeEvent<HTMLInputElement>) => {
        const { files } = event.target;
        const optionFileToCheck = checkedOption.inputs.find((input) => input.id === fieldId);
		const maxSize = optionFileToCheck.maxSize ?? DEFAULT_MAX_SIZE;
		setWarning(null);

		if (files?.[0]?.size > maxSize) {
			setWarning(`Размер файла превышает допустимый размер в ${Math.trunc(maxSize / DEFAULT_FILE_SIZE)} Мб`);
			event.target.value = "";
			return;
		}
		if (Array.isArray(optionFileToCheck?.format) && !checkValidFormat(files?.[0], optionFileToCheck?.format)) {
			setWarning(`Неверный формат файла: ${files?.[0]?.type}`);
			event.target.value = "";
			return;
		}

		const { filesUrl } = api;
		const apiUrl = `${filesUrl}${schema?.field ?? schema?.id}/file/`;

        const file = files[0];
        let newFileWithExtendedName;

        if (optionFileToCheck.forceNamePrefix) {
            const [_, ...fileExtension] = file.name.split('.')
            newFileWithExtendedName = new File([file], `${optionFileToCheck.forceNamePrefix}.${fileExtension.join('.')}`, {
                type: files[0].type
            });
        } else {
            newFileWithExtendedName = file;
        }

        const form_data = new FormData();
        form_data.append('file', newFileWithExtendedName);
        form_data.append('fileId', Guid.newGuid());

        api.uploadFileOption(apiUrl, form_data, {
            success: ({ data }) => {
                setInputs({
                    ...inputs,
                    [fieldId]: data
                });

                dispatcher.onBlur(schema?.field ?? schema.id, {
                    optionChecked: Number(checkedOption.name),
                    inputs: { ...inputs, [fieldId]: data }
                }, true, undefined)
            },
            error: (error) => {
                console.log(error);
                setWarning('Произошла ошибка. Попробуйте позже');
            }
        })
 	};

    const onDelete = (fieldId: string | null, fileId: string | null) => {
		const { moduleApi, filesUrl } = api;

		moduleApi && moduleApi?.deleteFile({ apiUrl: `${filesUrl}${schema.id}/${fileId}` }, {
			success: () => {
                let updatedValue;

                const removeFromInputs = (currentInput) => {
                    const copy = { ...currentInput };
                    delete copy[fieldId];
                    return copy;
                };
                const withoutRemoved = removeFromInputs(inputs);

                if (!fieldId) {
                    updatedValue = null;
                    setInputs(null);
                } else {
                    updatedValue = Object.keys(withoutRemoved).length > 0 ? {
                        optionChecked: Number(checkedOption.name),
                        inputs: removeFromInputs(inputs)
                    } : null;
                    setInputs(removeFromInputs);
                }

				dispatcher.onBlur(schema?.field ?? schema.id, updatedValue, true, undefined);
			},
			error: (error) => {
                console.log(error);
                setWarning('Произошла ошибка. Попробуйте позже');
            }
		});
	};

    const handleDescription = (fieldId: string) => {
        const fileToCheck = checkedOption.inputs.find((input) => input.id === fieldId);
        if (fileToCheck.description) {
            setDescription(fileToCheck.description.ru)
            setIsDescriptionOpened(!isDescriptionOpened);
        }
    };

    // @ts-ignore
	useEffect(() => {
		if (schema?.id && schema?.value) {
			setInputs(schema.value.inputs)
            setCheckedOption(schema.options.find((opt) => Number(opt.name) === schema.value.optionChecked))
		}
	}, []);

    return (
        <div id={id} className="form-group">
            <div className="col-xs-12 fullwidth">
                <label className="control-label">
                    {contentNumb && <div className="reportbox-content-num">{contentNumb}</div>}
                        <div className={cn("reportbox-content-desc", { required })}>
                            <span className={id}>
                                {title.ru}
                            </span>
                        </div>
                </label>
            </div>
            <div className="col-xs-12">
                <div className="input-group-cr">
					<div className="btn-group">
						{options.map((option: IRadiobuttonOption, idx: number) => (
							<label key={idx} className="radio-inline">
								<input
									type="radio"
									name={option.name}
									value={option.name}
									checked={option.name === checkedOption?.name}
									onChange={handleChange}
								/>
								{option.label.ru}
							</label>
						))}
					</div>
				</div>

                {
                    checkedOption?.inputs.map((input) => (
                        <div key={input?.id}>
                            <label className="control-label">
                                <div className="reportbox-content-desc">
                                    <span>
                                        {input?.name}
                                    </span>
                                </div>
                            </label>
                            <div className="input-group">
                                <FileInput
                                    id={input?.id}
                                    isLoading={false}
                                    onChange={onUpload(input?.id)}
                                    value={inputs?.[input?.id]}
                                />
                                <InputBtns
                                    fileDescription={input?.description}
                                    file={inputs?.[input?.id]}
                                    toggleDescription={handleDescription}
                                    docId={input?.id}
                                    onDelete={onDelete}
                                />
                            </div>
                        </div>
                    ))
                }
                <Alert type="warning" state={isDescriptionOpened} text={description} />
                <Alert type="danger" state={!!warning} text={warning} />
            </div>
        </div>
    )
};


export function createFileOptionComponent (
    schema: any,
    // TODO: abstract type any
    api: any,
    dispatcher: any,

    error: any,
    visited: boolean,
    // TODO: abstract type any
    opts: any,
    // TODO: abstract type any
    information: any,
    values: Array<{ controlid: string; value: unknown }>,
    rowIndex: number
): React.ReactElement<any> {
    return (
        <FileOption
            schema={schema}
            api={api}
            error={error}
            visited={visited}
            dispatcher={dispatcher}
            opts={opts}
            information={information}
            values={values}
            rowIndex={rowIndex}
        />
    );
}
